import * as React from "react";
import type { SVGProps } from "react";

interface MainProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Main = ({ cancelled = false, ...props }: MainProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    viewBox="0 0 66 66"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g strokeLinejoin="round">
        <path
          stroke="#FFF"
          strokeWidth={3}
          d="M21.966 6.53c5.057-.392 26.844 3.53 36.181 9.817.987.955-2.341.555-2.341.555l.87 2.868s-4.73 1.681-9.667 3.676l-.725.295q-.62.254-1.232.51l-.615.258c-3.495 1.481-7.475 2.792-7.617 3.657-.066.4-.144.807-.223 1.221-.33 1.73-.746 3.604-.08 5.555l.41 1.203-.936.503.072.359.109.504c.717 2.936 1.017 4.237 1.106 5.249l2.734 6.293c.478 1.055 1.144 2.203 1.932 3.019.406.421.83.808 1.321.826l2.115.08-.775 1.968c-.472 1.2-1.346 2.083-2.332 2.705-1.61 1.015-3.493 1.288-3.789 1.325-.025.003-2.323-1.44-4.544-4.077-.866-1.03-1.687-2.085-2.184-2.895l-2.68-4.656a31 31 0 0 0-1.092-.12l-.968-.215c-5.4-.919-13.81-2.96-18.399-6.812-.913-.767-1.485-1.916-1.618-3.43-.095-1.091.044-2.395.427-3.855-.917-1.948-1.013-4.278-.858-7.74.262-5.805 2.697-9.754 4.422-11.857a5.3 5.3 0 0 1-.01-1.112c.275-.282.44-.436.44-.436s5.172-4.823 10.546-5.24Z"
        />
        <path
          stroke="#000"
          strokeWidth={2}
          d="M22.005 7.03c5.012-.39 26.608 3.5 35.863 9.732.784.764-1.94.625-1.94.625l.58 1.912s-4.74 1.684-9.687 3.684l-.726.295q-.622.255-1.237.512l-.616.259-.57.24c-3.617 1.52-7.203 2.932-7.346 3.796-.065.396-.142.799-.22 1.209-.345 1.81-.758 3.77-.062 5.81l.273.801-.746.402c-.066.487.02.904.114 1.318.728 2.98 1.024 4.25 1.102 5.258l2.768 6.373c.5 1.106 1.204 2.308 2.029 3.163.51.53 1.06.956 1.662.979.418.015.824-.164 1.217-.439a4.8 4.8 0 0 1-.324 1.804c-.43 1.096-1.233 1.898-2.133 2.465-1.523.96-3.303 1.217-3.58 1.251-.025.003-2.112-1.538-4.103-3.902-.847-1.006-1.65-2.036-2.137-2.829l-2.8-4.865a38 38 0 0 0-1.326-.15l-.948-.211c-5.326-.905-13.642-2.899-18.173-6.704-.823-.69-1.323-1.732-1.442-3.09-.095-1.088.058-2.396.46-3.863-.966-1.922-1.044-4.217-.89-7.666.263-5.82 2.763-9.728 4.45-11.731-.056-.36-.065-.55-.065-.55.31-.784 5.328-5.483 10.553-5.889Z"
        />
      </g>
      <path
        fill="#565656"
        fillRule="nonzero"
        d="M37.11 46.697s2.827 7.577 6.099 7.7c-1.054 2.678-4.933 3.093-4.933 3.093s-5.333-5.583-5.676-7.196 4.51-3.597 4.51-3.597"
      />
      <path
        fill="#565656"
        fillRule="nonzero"
        d="m38.64 49.661-5.678 1.6-7.814-14.032 8.54 1.032z"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M32.064 46.193s-15.661-1.413-22.482-7.14c-1.36-1.142-1.435-3.574-.434-6.683q13.935 6.976 20.37 10.859 1.202.726 2.546 2.964"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M34.221 34.218c-7.575-4.974-6.457-4.383-7.594-8.21-1.136-3.825 8.713-10.33 8.713-10.33l-4.546-4.208-11.742-.383-5.303 1.53s-5.303 4.21-5.682 12.627.379 9.565 15.151 16.07c14.773 6.504-1.136 3.547 7.576 4.747s3.427-6 3.427-11.843"
      />
      <path
        fill="#19AEFC"
        fillRule="nonzero"
        d="M56.173 18.357s-20.455 7.27-20.833 9.565c-.38 2.296-1.152 4.84-.243 7.504-3.409 1.835-13.409-5.995-17.909-12.165s-4.738-10.4-4.738-10.4 4.708-4.452 9.632-4.835c4.924-.382 26.136 3.444 35.227 9.565.38.383-1.136.766-1.136.766"
      />
      <path
        stroke="#000"
        strokeLinecap="square"
        strokeWidth={2}
        d="M25.148 46.461q8.315.873 10.352-.672t1-5.289"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Main;
